import React from 'react';
import { useTranslation } from 'react-i18next';
import ContentPage from 'src/components/ContentPage/ContentPage';
import ReportingLinkList from 'src/features/siva/reporting/components/ReportingLinkList/ReportingLinkList';
import useSivaYearList from 'src/hooks/use-year-list-reporting';
const SivaFunds = () => {
  const { t } = useTranslation('siva');
  const yearList = useSivaYearList(2023);
  return (
    <ContentPage title={t('sivaAdmin.funds')}>
      <ReportingLinkList
        items={yearList.map((year) => ({
          to: `${year}`,
          title: `${t('sivaAdmin.funds')} ${year}`,
        }))}
      />
    </ContentPage>
  );
};
export default SivaFunds;
